<div class="homr-text-link-container hmf-justify-content-center hmf-text-align-center hmf-display-flex hmf-mb-m hmf-py-xs" >
	<div *ngIf="link; then linkMessage else messageOnly" ></div>
	<ng-template #linkMessage>
		<a href="{{ link }}" class="homr-text-link" data-em="homr-freeShipMessage" target="_blank">{{ message }}</a>
	</ng-template>
	<ng-template #messageOnly>
		<span class="message-text border">{{ message }}</span>
	</ng-template>
</div>
